import { getLanguage } from "@home/utils/common";
import { IMetrics } from "./types";

// 获取指标名称和同期对比的名称
export const getMetricsName = (metric: IMetrics, isEn = true) => {
  const { nameEn, nameCn,
    legendNameEn, legendNameCn,
    toolTipNameEn, toolTipNameCn,
    tableNameEn, tableNameCn,
    compareNameEn, compareNameCn,
    compareLegendNameEn, compareLegendNameCn,
    compareToolTipNameEn, compareToolTipNameCn,
    compareTableNameEn, compareTableNameCn,
  } = metric || {};
  const metricName = getLanguage(isEn, nameEn, nameCn) || "";
  const legendName = getLanguage(isEn, legendNameEn, legendNameCn) || metricName;
  const toolTipName = getLanguage(isEn, toolTipNameEn, toolTipNameCn) || metricName;
  const tableName = getLanguage(isEn, tableNameEn, tableNameCn) || metricName;
  const compareName = getLanguage(isEn, compareNameEn, compareNameCn) || "";
  const compareLegendName = getLanguage(isEn, compareLegendNameEn, compareLegendNameCn) || compareName;
  const compareToolTipName = getLanguage(isEn, compareToolTipNameEn, compareToolTipNameCn) || compareName;
  const compareTableName = getLanguage(isEn, compareTableNameEn, compareTableNameCn) || compareName;
  return {
    metricName,
    legendName,
    toolTipName,
    tableName,
    compareName,
    compareLegendName,
    compareToolTipName,
    compareTableName,
  };
};